export class PreQualData {
    request_no: string = "";
    is_coapplicant_applied: string = "";
    is_primary_applicant_CIBC_customer: boolean = false;
    are_both_applicants_CIBC_customer: string = '';
    users: Array<Applicant> = [];
    lang_ref: string = '';
    creation_date: Date;
    referralLink: any = null;
    updation_date: Date;
    request_id: string = ""; //15 digit number
    lang_pref: string; //en and fr
    is_existing_bankcustomers: string = ""
    created_at: number; //timestamp of d-m-y h:i:s
    updated_at: number; //timestamp of d-m-y h:i:s
    status: string; //inprogress, failed, complete
    total_gross_income: number;
    preQualify_mortgage_reference_number: number; //10 digit number
    preQualify_mortgage_amount: number;
    preQualify_purchase_price: number;
    cmhc_default_insurance: number;
    total_mortgage_amount: number;
    down_payment: number;
    failure_reason: string; //reason for failure, default null
    flow_type: string;
    mortgage_balance: string;
    maturity: string;
    switch_intrest_rate: string;
    madvsior: {
        ma_user_id: "abc",
        firstname: "Jack",
        lastname: "Trevor",
        email: "advsior@gmail.com",
        phone_number: "12121"
    }
    constructor() {
        this.flow_type = "P"
    }
}
export class Applicant {
    first_name: string = '';
    middle_name: string = '';
    last_name: string = '';
    suffix: string = '';
    age: number = 0;
    email: string = '';
    phone: string = '';
    is_primary_applicant: boolean = false;
    constructor() {
    }
}
export class Error {
    code: string = '';
    field: string = '';
    type: string = '';
    subtype: string = '';
}
export class maModel{
    ma_user_id: string;
    firstname: string;
    lastname: string;
    email: string;
    phone_number: string;
    asm_email: string;
    constructor() {
        this.ma_user_id = "";
        this.firstname = "";
        this.lastname = "";
        this.email = "";
        this.phone_number = "";
        this.asm_email = "";
  }
}